// extracted by mini-css-extract-plugin
module.exports = {"loader-root":"Loader_loader-root__219S5","flight":"Loader_flight__ZYDWD","shadow-one":"Loader_shadow-one__meTBe"};